/* eslint-disable max-len */
const motorVehicle = require('./motor-vehicle.json');
const invoice = require('./invoice.json');

/**
 * Collateral Motor Vehicle Schema.
 * No additional properties are allowed.
 * @typedef {Object} SalesVXCollateralMotorVehicle
 * @property {number} typeId - The unique identifier for the type. Required.
 * @property {?string} vinChassisNumber - The Vehicle Identification Number (VIN) or chassis number. Must be exactly 17 characters if provided.
 * @property {?string} nvic - The NVIC code of the vehicle.
 * @property {?string} body - The body type of the vehicle.
 * @property {?string} series - The series of the vehicle.
 * @property {?string} transmission - The transmission type of the vehicle
 * @property {?string} variant - The variant of the vehicle.
 * @property {?string} className - The class name of the vehicle.
 * @property {?string} crumbsRegistrationState - The registration state.
 * @property {?string} engineNumber - The engine number of the vehicle.
 * @property {?string} registrationNumber - The registration number of the vehicle.
 * @property {?string} co2 - The CO2 emissions of the vehicle.
 * @property {?number} odometerReading - The odometer reading of the vehicle.
 * @property {?number} manufactureMonth - The month the vehicle was manufactured.
 * @property {?number} manufactureYear - The year the vehicle was manufactured.
 * @property {?number} complianceMonth - The compliance month of the vehicle.
 * @property {?number} complianceYear - The compliance year of the vehicle.
 * @property {string} purchasePrice - The purchase price.
 * @property {Object} vehicle - Details of the vehicle. Required.
 * @property {string} vehicle.text - A descriptive text for the vehicle.
 * @property {?string} vehicle.green - Environmental tag of the vehicle.
 * @property {string} vehicle.id - The unique identifier for the vehicle.
 * @property {string} vehicle.description - A detailed description of the vehicle.
 * @property {string} vehicle.make - The make of the vehicle.
 * @property {string} vehicle.makeSlug - A slug representation of the make.
 * @property {string} vehicle.model - The model of the vehicle.
 * @property {string} vehicle.modelSlug - A slug representation of the model.
 * @property {number} vehicle.year - The manufacturing year of the vehicle.
 * @property {string} vehicle.class - The classification of the vehicle.
 * @property {?number} classId - The unique identifier for the class.
 * @property {?string} make - The make of the vehicle.
 * @property {?number} year - The manufacturing year of the vehicle.
 * @property {?string} model - The model of the vehicle.
 * @property {?string} description - A description of the vehicle.
 */

/**
 * Collateral Invoice Schema.
 * No additional properties are allowed.
 * @typedef {Object} SalesVXCollateralInvoice
 * @property {string} crumbsSupplierPartyRoleId - The crumbs party role Id of the supplier.
 * @property {string} collateralId - The collateral Id.
 * @property {string} invoiceAmount - The invoice amount.
 * @property {number} gstAmount - The GST Amount.
 */

/**
 * Sale related validation schemas for collateral
 * @module schemas/sales/collateral
 * @property {SalesVXCollateralMotorVehicle} motorVehicle
 * @property {SalesVXCollateralInvoice} invoice
 */
module.exports = {
  motorVehicle,
  invoice,
};
